import { Component, Input } from '@angular/core';

@Component({
  selector: 'no-data',
  template: `
  <div class="absolute inset-0 flex flex-col min-w-0 overflow-y-auto" cdkScrollable>

    <!-- Main -->
    <div class="flex-auto">
        <div class="w-full grid place-content-center h-full">
          <img [src]="'no_data.png' | imagePath" class="object-contain max-w-[230px] max-h-[230px]" alt="">
          <P class="font-medium text-[22px] leading-[23px] text-[#0b0d13] mx-auto mt-8">{{noDataLabel}}</P>
        </div>
    </div>
  </div> 
  `,
  styles: [
  ]
})
export class NoDataComponent {
  @Input("noDataLabel") noDataLabel: string = 'No Data';
}
